import { EmptyState } from "@cntrl/ui";
import styles from "./MerchShelfCard.module.scss";

/**
 * The Antenna Merch Shelf card (shot-42) — a PURE born-blank placeholder. There is NO merch endpoint
 * yet: the merch catalog is core Phase 6, so this card has no hook, no query, and NEVER fabricates sample
 * products (the born-blank tenancy contract). It simply reserves the hub slot and
 * names what's coming, so the surface is designed rather than blank.
 */
export function MerchShelfCard() {
  return (
    <section className={styles.card} aria-label="Antenna Merch Shelf">
      <EmptyState
        title="Antenna Merch Shelf"
        description="Sell merch straight to your fans — the merch shelf arrives with the core catalog."
      />
    </section>
  );
}
